// gets a rule from the specified sheet, or searches all sheets
const getCSSRule = (ruleName, sheetId, deleteFlag) => {
    try {
        ruleName = ruleName.toLowerCase();

        const trySheet = function (styleSheet) {
            if (styleSheet == null) {
                return;
            }
            try {
                // in firefox, this can throw a security exception under some (I have no idea what triggers it) conditions
                const ignore = styleSheet.cssRules;
            } catch (e2) {
                return;
            }
            let ii = 0;
            let cssRule = false;
            do {
                if (styleSheet.cssRules) {
                    cssRule = styleSheet.cssRules[ii];
                } else if (styleSheet.rules) {
                    cssRule = styleSheet.rules[ii];
                } else {
                    // in chrome, styleSheet.cssRules can be null, so we need the extra check
                    continue;
                }
                if (cssRule) {
                    if (cssRule.selectorText &&
                        cssRule.selectorText.toLowerCase() == ruleName) {
                        if (deleteFlag == 'delete') {
                            if (styleSheet.cssRules) {
                                styleSheet.deleteRule(ii);
                            } else {
                                styleSheet.removeRule(ii);
                            }
                            return true;
                        }
                        return cssRule;
                    }
                }
                ii++;
            } while (cssRule);
        };

        if (document.styleSheets) {
            if (sheetId) {
                var styleSheet = null;
                const el = document.getElementById(sheetId);
                if (el) {
                    styleSheet = el.styleSheet || el.sheet;
                }
                var result = trySheet(styleSheet);
                if (result) {
                    return result;
                }
            } else {
                for (let i = 0; i < document.styleSheets.length; i++) {
                    var styleSheet = document.styleSheets[i];
                    var result = trySheet(styleSheet);
                    if (result) {
                        return result;
                    }
                }
            }
        }
    } catch (e) {
        if (window && window.console && window.console.error) {
            window.console.error(e);
        }
    }
    return false;
};
export default getCSSRule;
